import React from 'react';
import config from 'react-global-configuration';
import { useTranslation } from 'react-i18next';

import { Image, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { Button } from '../../../../components';
import { DOMAIN_KVNL } from '../../../../config/constants';

import './style.scss';

const ThemeCard = ({ entity }) => {
  const { t } = useTranslation();

  const themesEnabled = config.get('THEMES_ENABLED');
  const currentDomain = config.get('CURRENT_DOMAIN');

  if (!themesEnabled || currentDomain === DOMAIN_KVNL) {
    return null;
  }

  const title = entity.getIn(['name', 0, 'value'], '');
  const url = entity.getIn(['paths', 'nl']);
  const description = entity.getIn(['field_teaser_description', 0, 'processed'], '');
  const icon = entity.getIn(['field_media_image', 0, 'source']);
  const alt = entity.getIn(['field_media_image', 0, 'entity', 'field_media_svg', 0, 'alt'], '');

  return (
    <div className="Theme__card">
      <div className="Theme__card__text">
        <div className="Theme__card__text__theme">{t('tags.theme')}</div>
        <h3>{title}</h3>
        <div className="Theme__card__text__description">
          <WysiwygField
            property="schema:text"
            html={description}
          />
        </div>
        {url && (
          <Button
            href={url}
          >
            {t('implementations.taxonomy.more_about_theme')}
          </Button>
        )}

      </div>
      <div className="Theme__card__icon">
        <Image src={icon} alt={alt} />
      </div>
    </div>
  );
};

export default ThemeCard;
